import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useParams } from 'react-router-dom'
import { auth } from 'service/api'
import { toast } from 'sonner'

export default function RevogarAcesso() {
    const { id } = useParams()
    const { mutateAsync, isLoading } = auth.historico.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!id) return null

    const handleSubmit = () =>
        mutateAsync(id as any, {
            onSuccess: () => {
                toast.success('Acesso revogado com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="40rem"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'HistóricoDeLogin'])}
        >
            <Dialog.Title>Realmente deseja revogar o acesso?</Dialog.Title>
            <Dialog.Content>
                Ao revogar o acesso de um usuário, ele continuará logado, mas
                não poderá mais autenticar automaticamente após um dia. Para que
                ele seja desconectado, é necessário que ele faça logout
                manualmente ou altere a senha.
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Revogar acesso
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
